import router from './router'
import courtOfJusticeMessages from './localization'

export default {
  router,
  localization: courtOfJusticeMessages,
}
